export const AWARENESS_PALETTE = [
  'var(--awareness-color-1)',
  'var(--awareness-color-2)',
  'var(--awareness-color-3)',
  'var(--awareness-color-4)',
  'var(--awareness-color-5)',
  'var(--awareness-color-6)',
  'var(--awareness-color-7)',
  'var(--awareness-color-8)',
] as const;

// FNV-1a 32-bit — deterministic, distribution-friendly for short strings.
function fnv1a(input: string): number {
  let hash = 0x811c9dc5;
  for (let i = 0; i < input.length; i++) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
}

export function resolveUserColor(userId: string): string {
  const index = fnv1a(userId) % AWARENESS_PALETTE.length;
  return AWARENESS_PALETTE[index];
}
